import Model from './base';

export class SearchHistory extends Model {
  resource() {
    return 'catalog/search-history';
  }

  defaultAttributes() {
    return {
      query: null,
      user: null,
      session_key: null,
      date: null,
      express: false,
      not_found: [],
      multiple: [],
      price_request_items: [],
      shortage: [],
      success: [],
      duplicates: [],
    }
  }
}
